<!--
 * @Description: 弹窗设置参数
 * @Autor: yjx
 * @Date: 2021-12-07 17：37：51
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-29 17:22:35
-->
<template>
    <el-dialog title="标准设置" :visible="visible" width="500px" append-to-body @close="onClose" @open="onOpen">
        <el-form ref="form" :model="form" label-width="140px" class="form">
            <el-form-item v-for="(item, key) in form" :key="key" :label="item? item.title + '：': ''">
                <div v-if="item" :class="item.text ? 'text' : ''">
                    <div v-if="item.text" class="t">{{item.text}}</div>
                    <div v-if="item.valType === 'input'">
                        <el-input v-model="item.resultValue" v-input-limit="item.limit || /''/" type="number" :style="item.style" placeholder="请输入" :disabled="item.disabled" @change="handleChange">
                            <i slot="suffix">{{ item.unit || '' }}</i>
                        </el-input>
                    </div>
                    <div v-else-if="item.valType === 'date'">
                        <el-date-picker
                            v-model="item.resultValue"
                            type="datetime"
                            format="HH:mm"
                            value-format="timestamp"
                            placeholder="请选择"
                            :disabled="item.disabled">
                            <i slot="suffix">{{ item.unit || '' }}</i>
                        </el-date-picker>
                    </div>
                    <div v-else-if="item.valType === 'calc'">{{item.resultValue}}</div>
                </div>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button class="bottom_all_two" @click="onClose">取 消</el-button>
            <el-button class="bottom_all" type="primary" @click="onConfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            data: [],
            form: {},
        }
    },
    props: {
        config: {
            type: Object,
            default: () => {},
        },
        visible: {
            type: Boolean,
            default: false,
        },
    },
    // watch: {
    //     form: {
    //         handler: function() {
    //             const form = this.form;

    //             if(this.config.key === 'zyszzb') { // 总压碎指标
    //                 const {yszbsyz1, yszbzl1, yszbsyz2, yszbzl2, yszbsyz3, yszbzl3, yszbsyz4, yszbzl4} = form;
    //                 form.yszb1 = yszbsyz1 && yszbzl1 ? ((yszbsyz1 - yszbzl1) / yszbsyz1).toFixed(2) : ''
    //                 form.yszb2 = yszbsyz2 && yszbzl2 ? ((yszbsyz2 - yszbzl2) / yszbsyz2).toFixed(2) : ''
    //                 form.yszb3 = yszbsyz3 && yszbzl3 ? ((yszbsyz3 - yszbzl3) / yszbsyz3).toFixed(2) : ''
    //                 form.yszb4 = yszbsyz4 && yszbzl4 ? ((yszbsyz4 - yszbzl4) / yszbsyz4).toFixed(2) : ''
    //                 form.zyszzb =
    //                     form.yszb1 && form.yszb2 && form.yszb3 && form.yszb4 ?
    //                     ((form.yszbzl1 * form.yszb1 + form.yszbzl2 * form.yszb2 + form.yszbzl3 * form.yszb3 + form.yszbzl4 * form.yszb4) / (form.yszbzl1 + form.yszbzl2 + form.yszbzl3 + form.yszbzl4)).toFixed(2)
    //                     :
    //                     ''
    //                 return
    //             }
    //             if(this.config.key === 'cnsj') { // 初凝时间
    //                 const {cnsjsjjssj, cnsjjzjssj, sjcnsj1, sjcnsj2, sjcnsj3, jzcnsj1, jzcnsj2, jzcnsj3} = form;
    //                 form.sjcnsj = sjcnsj1 && sjcnsj2 && sjcnsj3 && cnsjsjjssj ? (((sjcnsj1 - cnsjsjjssj) + (sjcnsj2 - cnsjsjjssj) + (sjcnsj3 - cnsjsjjssj)) / 3 / 1000 / 60).toFixed(1) : ''
    //                 form.jzcnsj = jzcnsj1 && jzcnsj2 && jzcnsj3 && cnsjjzjssj ? (((sjcnsj1 - cnsjjzjssj) + (sjcnsj2 - cnsjjzjssj) + (sjcnsj3 - cnsjjzjssj)) / 3 / 1000 / 60).toFixed(1) : ''
    //                 form.cnsj = form.sjcnsj && form.jzcnsj ? (form.sjcnsj - form.jzcnsj).toFixed(1) : '';
    //                 return
    //             }
    //             if(this.config.key === 'znsj') { // 终凝时间
    //                 const {znsjsjjssj, znsjjzjssj, sjznsj1, sjznsj2, sjznsj3, jzznsj1, jzznsj2, jzznsj3} = form;
    //                 form.sjznsj = sjznsj1 && sjznsj2 && sjznsj3 && znsjsjjssj ? (((sjznsj1 - znsjsjjssj) + (sjznsj2 - znsjsjjssj) + (sjznsj3 - znsjsjjssj)) / 3 / 1000 / 60).toFixed(1) : ''
    //                 form.jzznsj = jzznsj1 && jzznsj2 && jzznsj3 && znsjjzjssj ? (((sjznsj1 - znsjjzjssj) + (sjznsj2 - znsjjzjssj) + (sjznsj3 - znsjjzjssj)) / 3 / 1000 / 60).toFixed(1) : ''
    //                 form.znsj = form.sjznsj && form.jzznsj ? (form.sjznsj - form.jzznsj).toFixed(1) : '';
    //                 return
    //             }
    //             if(this.config.key === 'jsjsl') { // 胶砂减水率
    //                 const {jzjsdwysl1, jzjsdwysl2, jzjsdwysl3, sjjsdwysl1, sjjsdwysl2, sjjsdwysl3} = form;
    //                 form.jsljs1 = jzjsdwysl1 && sjjsdwysl1 ? ((jzjsdwysl1 - sjjsdwysl1) / jzjsdwysl1).toFixed(1) : ''
    //                 form.jsljs2 = jzjsdwysl2 && sjjsdwysl2 ? ((jzjsdwysl2 - sjjsdwysl2) / jzjsdwysl2).toFixed(1) : ''
    //                 form.jsljs3 = jzjsdwysl3 && sjjsdwysl3 ? ((jzjsdwysl3 - sjjsdwysl3) / jzjsdwysl3).toFixed(1) : ''
    //                 form.jsjsl = form.jsljs1 && form.jsljs2 && form.jsljs3 ? ((form.jsljs1 + form.jsljs2 + form.jsljs3) / 3).toFixed(1) : ''
    //             }
    //             if(this.config.key === 'hntjsl') { // 混凝土减水率
    //                 const {jzhntdwysl1, jzhntdwysl2, jzhntdwysl3, sjhntdwysl1, sjhntdwysl2, sjhntdwysl3} = form;
    //                 form.jslhnt1 = jzhntdwysl1 && sjhntdwysl1 ? ((jzhntdwysl1 - sjhntdwysl1) / jzhntdwysl1).toFixed(1) : ''
    //                 form.jslhnt2 = jzhntdwysl2 && sjhntdwysl2 ? ((jzhntdwysl2 - sjhntdwysl2) / jzhntdwysl2).toFixed(1) : ''
    //                 form.jslhnt3 = jzhntdwysl3 && sjhntdwysl3 ? ((jzhntdwysl3 - sjhntdwysl3) / jzhntdwysl3).toFixed(1) : ''
    //                 form.hntjsl = form.jslhnt1 && form.jslhnt2 && form.jslhnt3 ? ((form.jslhnt1 + form.jslhnt2 + form.jslhnt3) / 3).toFixed(1) : ''
    //                 return;
    //             }
    //             if(this.config.key === 'jsss') { // 1h经时损失
    //                 const {cstld1, cstld2, cstld3, onetld1, onetld2, onetld3} = form;
    //                 form.jsbhl1 = cstld1 && onetld1 ? (cstld1 - onetld1).toFixed(1) : ''
    //                 form.jsbhl2 = cstld2 && onetld2 ? (cstld2 - onetld2).toFixed(1) : ''
    //                 form.jsbhl3 = cstld3 && onetld3 ? (cstld3 - onetld3).toFixed(1) : ''
    //                 form.jsss = form.jsbhl1 && form.jsbhl2 && form.jsbhl3 ? ((form.jsbhl1 + form.jsbhl2 + form.jsbhl3) / 3).toFixed(1) : ''
    //                 return;
    //             }
    //             if(this.config.key === 'sslb28') { // 28天收缩率比
    //                 const {sjssl1, sjssl2, sjssl3, jzssl1, jzssl2, jzssl3} = form;
    //                 form.sjsslpjz = sjssl1 && sjssl2 && sjssl3 ? ((sjssl1 + sjssl2 + sjssl3) / 3).toFixed(1) : ''
    //                 form.jzsslpjz = jzssl1 && jzssl2 && jzssl3 ? ((jzssl1 + jzssl2 + jzssl3) / 3).toFixed(1) : ''
    //                 form.sslb28 = form.sjsslpjz && form.jzsslpjz ? (form.sjsslpjz / form.jzsslpjz).toFixed(1) : ''
    //                 return;
    //             }
    //             if(this.config.key === 'mslb') { // 泌水率比
    //                 const {sjhntmszzl1, sjhntmszzl2, sjhntmszzl3, sjhntbhwysl1, sjhntbhwysl2, sjhntbhwysl3, sjhntbhwzzl1, sjhntbhwzzl2, sjhntbhwzzl3, sjsyzl1, sjsyzl2, sjsyzl3,
    //                         jzhntmszzl1, jzhntmszzl2, jzhntmszzl3, jzhntbhwysl1, jzhntbhwysl2, jzhntbhwysl3, jzhntbhwzzl1, jzhntbhwzzl2, jzhntbhwzzl3, jzsyzl1, jzsyzl2, jzsyzl3
    //                     } = this.form
    //                 form.sjhntmsl1 = sjhntmszzl1 && sjhntbhwysl1 && sjhntbhwzzl1 && sjsyzl1 ? (sjhntmszzl1 / (sjhntbhwysl1 / sjhntbhwzzl1 * sjsyzl1)).toFixed(1) : ''
    //                 form.sjhntmsl2 = sjhntmszzl2 && sjhntbhwysl2 && sjhntbhwzzl2 && sjsyzl2 ? (sjhntmszzl2 / (sjhntbhwysl2 / sjhntbhwzzl2 * sjsyzl2)).toFixed(1) : ''
    //                 form.sjhntmsl3 = sjhntmszzl3 && sjhntbhwysl3 && sjhntbhwzzl3 && sjsyzl3 ? (sjhntmszzl3 / (sjhntbhwysl3 / sjhntbhwzzl3 * sjsyzl3)).toFixed(1) : ''
    //                 form.sjhntmsl = form.sjhntmsl1 && form.sjhntmsl2 && form.sjhntmsl3 ? ((form.sjhntmsl1 + form.sjhntmsl2 + form.sjhntmsl3) / 3).toFixed(1) : ''
    //                 form.jzhntmsl1 = jzhntmszzl1 && jzhntbhwysl1 && jzhntbhwzzl1 && jzsyzl1 ? (jzhntmszzl1 / (jzhntbhwysl1 / jzhntbhwzzl1 * jzsyzl1)).toFixed(1) : ''
    //                 form.jzhntmsl2 = jzhntmszzl2 && jzhntbhwysl2 && jzhntbhwzzl2 && jzsyzl2 ? (jzhntmszzl2 / (jzhntbhwysl2 / jzhntbhwzzl2 * jzsyzl2)).toFixed(1) : ''
    //                 form.jzhntmsl3 = jzhntmszzl3 && jzhntbhwysl3 && jzhntbhwzzl3 && jzsyzl3 ? (jzhntmszzl3 / (jzhntbhwysl3 / jzhntbhwzzl3 * jzsyzl3)).toFixed(1) : ''
    //                 form.jzhntmsl = form.jzhntmsl1 && form.jzhntmsl2 && form.jzhntmsl3 ? ((form.jzhntmsl1 + form.jzhntmsl2 + form.jzhntmsl3) / 3).toFixed(1) : ''
    //                 form.mslb = form.sjhntmsl && form.jzhntmsl ? (form.sjhntmsl / form.jzhntmsl).toFixed(0) : ''
    //             }
    //             if(this.config.key === 'xzpzl7') { // 限制膨胀率7天
    //                 const {jzcd7, cscd7, cd7_1, cd7_2} = this.form;
    //                 form.pzl7_1 = jzcd7 && cscd7 && cd7_1 ? ((jzcd7 + cscd7 + cd7_1) / 3).toFixed(3) : ''
    //                 form.pzl7_2 = jzcd7 && cscd7 && cd7_2 ? ((jzcd7 + cscd7 + cd7_2) / 3).toFixed(3) : ''
    //                 form.xzpzl7 = form.pzl7_1 && form.pzl7_2 ? ((form.pzl7_1 + form.pzl7_2) / 2).toFixed(3) : ''
    //             }
    //             if(this.config.key === 'xzpzl21') { // 限制膨胀率21天
    //                 const {jzcd21, cscd21, cd21_1, cd21_2} = this.form;
    //                 form.pzl21_1 = jzcd21 && cscd21 && cd21_1 ? ((jzcd21 + cscd21 + cd21_1) / 3).toFixed(3) : ''
    //                 form.pzl21_2 = jzcd21 && cscd21 && cd21_2 ? ((jzcd21 + cscd21 + cd21_2) / 3).toFixed(3) : ''
    //                 form.xzpzl21 = form.pzl21_1 && form.pzl21_2 ? ((form.pzl21_1 + form.pzl21_2) / 2).toFixed(3) : ''
    //             }
    //             if(this.config.key === 'jzhntqd7') { // 泵送剂基准混凝土7天强度
    //               const {jzhntqd7_1, jzhntqd7_2, jzhntqd7_3} = this.form;
    //               form.jzhntqd7 = (jzhntqd7_1+jzhntqd7_2+jzhntqd7_3)/3
    //             }
    //             if(this.config.key === 'jzhntqd28') { // 泵送剂基准混凝土28天强度
    //                 const {jzhntqd28_1, jzhntqd28_2, jzhntqd28_3} = this.form;
    //                 form.jzhntqd28 = (jzhntqd28_1+jzhntqd28_2+jzhntqd28_3)/3
    //             }

    //             const computed = {
    //                 '1': {
    //                     syhlhl: isNaN((form.syhlzshzz - form.syhlkggz) / form.syhlsyz) ? '' : ((form.syhlzshzz - form.syhlkggz) / form.syhlsyz).toFixed(2),
    //                     ssl: isNaN((form.sslzshzz - form.sslkggz) / form.sslsyz) ? '' : ((form.sslzshzz - form.sslkggz) / form.sslsyz).toFixed(2),
    //                 },
    //                 '2': {
    //                     syhlhl: isNaN((form.syhlzshzz - form.syhlkggz) / form.syhlsyz) ? '' : ((form.syhlzshzz - form.syhlkggz) / form.syhlsyz).toFixed(2),
    //                     hsl: isNaN(form.hgqsyzl - form.hghsyzl) ? '' : (form.hgqsyzl - form.hghsyzl).toFixed(1),
    //                     md: isNaN(form.mdsyz / (form.mddyckd - form.mddeckd)) ? '' : (form.mdsyz / (form.mddyckd - form.mddeckd)).toFixed(2)
    //                 },
    //                 '3': {
    //                     md: isNaN(form.mdsyz / (form.mddyckd - form.mddeckd)) ? '' : (form.mdsyz / (form.mddyckd - form.mddeckd)).toFixed(2),
    //                     hsl: isNaN(form.hgqsyzl - form.hghsyzl) ? '' : (form.hgqsyzl - form.hghsyzl).toFixed(1),
    //                     syhlhl: isNaN((form.syhlzshzz - form.syhlkggz) / form.syhlsyz) ? '' : ((form.syhlzshzz - form.syhlkggz) / form.syhlsyz).toFixed(2),
    //                     ssl: isNaN((form.sslzshzz - form.sslkggz) / form.sslsyz) ? '' : ((form.sslzshzz - form.sslkggz) / form.sslsyz).toFixed(2),
    //                     llzhl: isNaN((form.llzhlkb - form.llzhldd) / form.llzhlsyz) ? '' : ((form.llzhlkb - form.llzhldd) / form.llzhlsyz).toFixed(2),
    //                 },
    //                 '4': {
    //                     md: isNaN(form.mdsyz / (form.mddyckd - form.mddeckd)) ? '' : (form.mdsyz / (form.mddyckd - form.mddeckd)).toFixed(2),
    //                     hsl: isNaN(form.hgqsyzl - form.hghsyzl) ? '' : (form.hgqsyzl - form.hghsyzl).toFixed(1),
    //                     syhlhl: isNaN((form.syhlzshzz - form.syhlkggz) / form.syhlsyz) ? '' : ((form.syhlzshzz - form.syhlkggz) / form.syhlsyz).toFixed(2),
    //                     ssl: isNaN((form.sslzshzz - form.sslkggz) / form.sslsyz) ? '' : ((form.sslzshzz - form.sslkggz) / form.sslsyz).toFixed(2),
    //                 },
    //                 '5': {},
    //                 '6': {},
    //                 '7': {
    //                     hql: form.hql1 && form.hql2 && form.hql3 ? ((form.hql1 + form.hql2 + form.hql3) / 3).toFixed(1) : '',
    //                     hgl: form.ytsyzl && form.hghzl ? (form.hghzl / form.ytsyzl).toFixed(1) : '',
    //                 },
    //                 '8': {},
    //             }
    //             this.form[this.config.key] = computed[this.config.index][this.config.key]
    //         },
    //         deep: true,
    //     },
    // },
    methods: {
        onOpen() {
            this.form = this.config.form
            console.log(this.form)
        },
        onClose() {
            // 关闭弹框
            this.$emit('update:visible', false)
        },
        onConfirm() {
            // 确定
            for (const key in this.form) {
                console.log(key)
                let val = this.form[key].resultValue
                if (val === undefined || val.length === 0 || Number(val) < 0) {
                    return this.$message.warning('请正确输入数据')
                }
            }
            this.$emit('updated', { key: this.config.key, data: this.form })
            this.$emit('update:visible', false)
        },
        handleChange() {
            this.$emit('formChange', this.form)
            // console.log(22, typeof this.config.changeFun)
            // if (typeof this.config.changeFun === 'function') {
            //     this.config.changeFun(this.form)
            // }
        }
    },
}
</script>

<style lang="scss" scoped>
.form {
    max-height: 500px;
    overflow-y: auto;
}
.text {
    position: relative;
    
    .t {
        position: absolute;
        top: -40px;
        left: -120px;
    }
}
</style>
